import React, { useEffect, useState } from "react";
import Footer from "../component/Footer/FooterCommon";
import HeroContent from "../component/HeroContent/HeroContent";
import Navbar from "../component/Navbar/NavbarCommon";
import BirthdayTemplate from "../component/Templates/BirthdayTemplate";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import AnniversaryTemplate from "../component/Templates/AnniversaryTemplate";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import BirthdayCard from "../component/HeroContent/BirthdayCard";
import AnniversaryCard from "../component/HeroContent/AnniversaryCard";
import { api } from "../api";
import { API_URL, ASSETS_URL } from "../utils/config";
import { toast } from "react-toastify";
import { BannersTypes, ResponseTypes } from "../api/types";
import { AxiosResponse } from "axios";
import { useAccountStore } from "../store/useAccountStore";
import { useCountryStore } from "../store/useCountryStore";
import useAuth from "../hooks/useAuth";
const Hero: React.FC = () => {
  const [banners, setbanners] = useState<BannersTypes[]>([]);
  const [birthdayList, setbirthdayList] = useState([])
  const [aniversaryList, setaniversaryList] = useState([])
  const {user}=useAccountStore()
  const { country } = useCountryStore();
  useEffect(() => {
    fetchAllBanners();
    fetchAllUsersWithBirthdayAndAniversary()
  }, [country]);
  const fetchAllBanners = async () => {
    try {
      const { error, data } = await api.get<ResponseTypes>(API_URL.banners);
      if (error) {
        // toast.error(error.message);
        return;
      }
      console.log(data);
      
      if(data) setbanners(data.data);
      
    } catch (error) {
      // toast.error(error?.message)
    }
  };
  const fetchAllUsersWithBirthdayAndAniversary = async () => {
    try {
      // Pass country parameter to get country-specific data
      const countryParam = country?.name || "India";
      const { error, data } = await api.get<ResponseTypes>(`${API_URL.today}?country=${countryParam}`);
      if (error) {
        // toast.error(error.message);
        return;
      }
      console.log(data);

      if(data) {
        setaniversaryList((data as any)?.data?.anniversaries || [])
        setbirthdayList((data as any)?.data?.birthdays|| [])
      }


    } catch (error) {
      // toast.error(error?.message)
    }
  };

  return (
    <div className="h-screen w-screen overflow-x-hidden">
      {/* Navbar */}
      <div>
        <Navbar />
      </div>
      {/* Hero Section */}

      <div className="relative items-center w-full h-[80%] bg-pealgreen px-4 md:px-5 lg:px-9 xl:px-10 pt-[120px] flex flex-col md:flex-row md:justify-between gap-5 ">
        <div className={`md:w-[75%] h-auto flex md:items-center ${!user ? 'mx-auto' : ''}`}>
          <div className="relative lg:h-[79%] h-full">
            <Carousel
              showArrows={false}
              showThumbs={false}
              showStatus={false}
              infiniteLoop
              
              autoPlay
              interval={3000}
              transitionTime={1000}
              showIndicators={true}
              // swipeable={true}
              emulateTouch={true}
              className="w-full h-full overflow-hidden  "
            >
              {
                banners?.map((item)=>(
                  <div key={item?.imageUrl} className="w-full h-full rounded-lg overflow-hidden">
                  <img
                    src={`${ASSETS_URL}${item?.imageUrl}`}
                    alt={item?.note}
                    className="w-full h-full object-fill"
                  />
                </div>
                ))
              }
{/*              
              <div className="w-full h-full rounded-lg">
                <img
                  src="/assets/150year.png"
                  alt="150 Years"
                  className="w-full h-full object-cover"
                />
              </div> */}
            </Carousel>
          </div>
        </div>
        {user&&<div className="flex justify-center items-center h-auto w-full md:w-[22%]  bg-pealgreen">
          <HeroContent />
        </div>}
      </div>
      {user&&<div className="flex flex-col sm:flex-row w-full sm:h-[60%] bg-transparent px-4 md:px-5 lg:px-9 xl:px-10 items-center justify-center gap-14 mb-44">
  <BirthdayCard birthdayList={birthdayList}/>
  <AnniversaryCard anniversaryList={aniversaryList}/>
</div>}

      {/* <div
        className="relative h-screen w-full min-h-screen overflow-hidden"
        style={{
          backgroundImage: "url('assets/AO-smith-bg.png')",
          backgroundSize: '100% auto',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#1a1a1a'
        }}
      >
      
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/40 via-green-800/20 to-transparent"></div>

    
        <div className="absolute left-0 top-0 w-full h-full overflow-hidden z-5">
          <svg
            className="absolute left-0 top-0 w-full h-full"
            viewBox="0 0 1920 1080"
            preserveAspectRatio="xMinYMin slice"
          >
            <defs>
              <linearGradient id="greenGradientMain" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#162A1E" stopOpacity="0.95" />
                <stop offset="20%" stopColor="#162A1E" stopOpacity="0.7" />
                <stop offset="40%" stopColor="#162A1E" stopOpacity="0.7 " />
                <stop offset="60%" stopColor="#162A1E" stopOpacity="0.7" />
                <stop offset="70%" stopColor="#162A1E" stopOpacity="0.7" />
                <stop offset="80%" stopColor="#162A1E" stopOpacity="0.2" />
                <stop offset="90%" stopColor="#162A1E" stopOpacity="0.1" />
                <stop offset="100%" stopColor="#162A1E" stopOpacity="0" />
              </linearGradient>
              <linearGradient id="greenGradientBottom" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#162A1E" stopOpacity="0" />
                <stop offset="39%" stopColor="white" stopOpacity="0" />
                <stop offset="0%" stopColor="#162A1E" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#162A1E" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#162A1E" stopOpacity="0.9" />
              </linearGradient>
              <filter id="naturalBlur" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="35" />
              </filter>
            </defs>


            <path
              d="M0 0 L1200 0 L1360 400 L1360 1080 L0 1080 Z"
              fill="url(#greenGradientMain)"
              filter="url(#naturalBlur)"
            />

           
            <path
              d="M0 0 L300 0 L450 400 L450 1080 L0 1080 Z"
              fill="#162A1E"
              opacity="0.8"
              filter="url(#naturalBlur)"
            />

          
            <path
              d="M0 0 L600 0 L750 400 L750 1080 L0 1080 Z"
              fill="#162A1E"
              opacity="0.8"
              filter="url(#naturalBlur)"
            />

           
            <path
              d="M0 0 L900 0 L1050 400 L1050 1080 L0 1080 Z"
              fill="#162A1E"
              opacity="0.8"
              filter="url(#naturalBlur)"
            />
            <path
              d="M0 0 L900 0 L1050 400 L1050 1080 L0 1080 Z"
              fill="#162A1E"
              opacity="1"
              filter="url(#naturalBlur)"
            />
          
            <path
              d="M0 0 L1100 0 L1250 400 L1250 1080 L0 1080 Z"
              fill="#162A1E"
              opacity="0"
              filter="url(#naturalBlur)"
            /><path
              d="M0 0 L1100 0 L1250 400 L1250 1080 L0 1080 Z"
              fill="#162A1E"
              opacity="0"
              filter="url(#naturalBlur)"
            />

           
            <rect
              x="960"
              y="540"
              width="960"
              height="550"
              fill="url(#greenGradientBottom)"
              filter="url(#naturalBlur)"
            />

           
            <rect
              x="1200"
              y="0"
              width="920"
              height="400"
              fill="#162A1E"
              opacity="0.9"
              filter="url(#naturalBlur)"
              className="hidden lg:block xl:hidden"
            />

           
            <path
              d="M1200 0 L1920 0 L1920 300 L1400 300 Z"
              fill="#162A1E"
              opacity="0.6"
              filter="url(#naturalBlur)"
              className="hidden lg:block xl:hidden"
            />
          </svg>
        </div>

     
        <div className="absolute bottom-0 left-0 w-full h-2/3 bg-gradient-to-t from-green-900/60 via-green-800/60 to-transparent"></div>

       
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      
        <div className="hidden lg:block h-screen relative z-10">

         

        
          <div className=" w-full absolute top-1/4">
            <HeroContent />
            <div className="flex w-full justify-center items-center gap-12  mt-20">
            <div className="relative bg-white rounded-xl shadow-2xl overflow-hidden w-[280px] lg:w-[300px] xl:w-[320px] h-[230px] lg:h-[250px] xl:h-[270px] mb-6 lg:mb-8">
              <BirthdayTemplate people={birthdayPeople} />
            </div>
            <div className="relative bg-white rounded-xl shadow-2xl overflow-hidden w-[280px] lg:w-[300px] xl:w-[320px] h-[230px] lg:h-[250px] xl:h-[270px] mb-6 lg:mb-8">
              <AnniversaryTemplate people={anniversaryPeople} />
            </div>
            </div>
            
          </div>
          <div>
               
         

            
            
          </div>
        </div>

       
        <div className="lg:hidden flex flex-col h-screen overflow-y-auto px-4 py-10 mt-8 relative z-10 pb-96">
        
  <div className="flex justify-center mb-6 flex-shrink-0 px-2 mt-7">
            <HeroContent />
          </div>
        
          <div className="flex flex-col items-center gap-4 mb-6 px-2">
           
            <div className="relative bg-white rounded-xl shadow-2xl overflow-hidden w-full max-w-[280px] sm:max-w-[300px] h-[240px] sm:h-[260px]">
              <BirthdayTemplate people={birthdayPeople} />
            </div>

          
            <div className="relative bg-white rounded-xl shadow-2xl overflow-hidden w-full max-w-[280px] sm:max-w-[300px] h-[240px] sm:h-[260px]">
              <AnniversaryTemplate people={anniversaryPeople} />
            </div>
          </div>

          
        
        </div>
      </div> */}

      {/* Footer */}
      <Footer bgColor="bg-white" textColor="text-black" />
    </div>
  );
};

export default Hero;
